import Slider from "@mui/material/Slider";
import "./YearSlider.css";

function YearSlider({ selectedYear, onYearChange, minYear = 2016, maxYear = 2025 }) {
  // Generate marks for each year
  const marks = [];
  for (let year = minYear; year <= maxYear; year++) {
    marks.push({
      value: year,
      label: year.toString(),
    });
  }

  const handleChange = (event, newValue) => {
    onYearChange(newValue);
  };

  return (
    <div className="year-slider-container">
      <Slider
        value={selectedYear}
        onChange={handleChange}
        min={minYear}
        max={maxYear}
        step={1}
        marks={marks}
        valueLabelDisplay="off"
        sx={{
          color: "#2f2f2f",
          "& .MuiSlider-thumb": {
            width: 24,
            height: 24,
            backgroundColor: "#2f2f2f",
            border: "3px solid #ffffff",
            "&:hover, &.Mui-focusVisible": {
              boxShadow: "0 3px 8px rgba(0, 0, 0, 0.4)",
            },
          },
          "& .MuiSlider-track": {
            height: 8,
            backgroundColor: "#2f2f2f",
          },
          "& .MuiSlider-rail": {
            height: 8,
            backgroundColor: "#e0e0e0",
            opacity: 1,
          },
          "& .MuiSlider-mark": {
            width: 2,
            height: 8,
            backgroundColor: "rgba(47, 47, 47, 0.3)",
          },
        }}
      />
    </div>
  );
}

export default YearSlider;

